module.exports = __webpack_public_path__ + "static/media/inf_98og99.c0ccccbf.mp3";